import { cn } from "@/utils/styles";

type StandardContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export const StandardContainer: React.FC<StandardContainerProps> = ({ children, className }) => {
  return <div data-testid="standardContainer" className={cn("px-3 lg:px-6", className)}>{children}</div>;
};
